<!-- Loader -->
<div class="loader-overlay" *ngIf="loading">
    <div class="loader"></div>
    <div class="loader-text">
        Detecting Issues...
    </div>
</div>
<div class="button-container mr-4">
    <button mat-raised-button color="basic" (click)="dialogRef.close()">
        Close
    </button>
</div>
<div class=" table-wrapper" *ngIf="!loading && hasData">

    <table class="simple-table">
        <thead>
            <tr>
                <th>Sr.NO.</th>
                <th>Voucher No</th>
                <th>Main Expense Name</th>
                <th>Issue</th>
                <th>Type</th>
                <th>Action</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let row of pagedIssues; let i = index">
                <td>{{ ((currentPage - 1) * pageSize) + i + 1 }}</td>
                <td>{{ row.voucher_no }}</td>
                <td><span class="badge code">{{ row.main_exp_name }}</span></td>
                <td>{{ row.error_type }}</td>
                <td>
                    <span>
                        {{ row.type }}
                    </span>
                </td>
                <td>
                    <button mat-icon-button color="primary" (click)="openVoucher(row)">
                        <mat-icon>open_in_new</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>

    <!-- Pagination -->
    <div class="pagination">
        <button mat-stroked-button (click)="prevPage()" [disabled]="currentPage === 1">
            ◀ Prev
        </button>

        <span class="page-info">
            Page {{ currentPage }} of {{ totalPages }}
        </span>

        <button mat-stroked-button (click)="nextPage()" [disabled]="currentPage === totalPages">
            Next ▶
        </button>
    </div>

</div>
<div *ngIf="!loading && !hasData" class="empty-state">
    <mat-icon class="empty-icon">check_circle</mat-icon>
    <div class="empty-title">All Good!</div>
    <div class="empty-subtitle">
        No issues found in credit vouchers
    </div>
</div>